// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomErrorPage_root__1vjS9","errorTitle":"CustomErrorPage_errorTitle__f265i","errorCopy":"CustomErrorPage_errorCopy__Mlr6g"};